import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";
import Section7 from "./Section7";

export default function PluginAndAppDevelopment() {
  return (
    <div className="Plugin-And-App-Development pt-[160px] sm:pt-0">
      <Helmet>
        <title>Custom Plugin & App Development - Mean3 Software Solutions</title>
        <meta
        name="description"
        content="Transform your ideas into powerful digital tools with Mean3. We specialize in custom plugin and app development for websites, stores, and platforms."
        />
      </Helmet>
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
      <Section6 />
      <Section7 />
    </div>
  );
}
